module.exports = __webpack_public_path__ + "media/images/merge-febcad1d1b3bd8dbce468593d360db93.svg";